import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SectionScrollService {
  private readonly router = inject(Router);

  navigateToLandingSection(anchor: string): void {
    const path = this.router.url.split('?')[0].split('#')[0];
    const isLanding = path === '/' || path === '';

    const scrollToElement = (): void =>
      document.getElementById(anchor)?.scrollIntoView({ behavior: 'smooth' });

    if (isLanding) {
      scrollToElement();
      return;
    }

    void this.router.navigate(['/']).then(() => {
      setTimeout(scrollToElement, 100);
    });
  }
}
